import { Route } from "@/routes/__root";

export const useRoles = () => {
  const user = useUser();

  if (!user?.groups) return [];

  return user.groups;
};

export const useUser = () => {
  const data = Route.useLoaderData();

  if (!data) return undefined;

  const { item } = data;

  return item;
};
